import React from 'react'
import { SocialAccount } from 'types/influencer'
import userDummyImg from "../../assets/images/users/user-dummy-img.jpg"

const PostPreviewCreator: React.FC<{ socialAccount: SocialAccount }> = ({ socialAccount }) => {
    return (
        <div className="d-flex align-items-center gap-2 mt-2">
            {socialAccount?.profile_picture_url ? (
                <img src={socialAccount?.profile_picture_url} className="rounded-circle square-30" alt="" />
            ) : (
                <img src={userDummyImg} className="rounded-circle square-30" alt="" />
            )}
            <div className="d-flex flex-column gap-0">
                <span className='content-masonry-creator-name' >{socialAccount?.name ?? `@${socialAccount?.handle}`}</span>
                {
                    socialAccount.name &&
                    <span className='content-masonry-creator-handle' >{`@${socialAccount?.handle}`}</span>
                }
            </div>
        </div>
    )
}

export default PostPreviewCreator